import {http} from '../utils/http'

const searchAction = (params, current, size) => {
  const url = `/config/apiConfigInfo/page`
  params.page = current
  params.size = size
  return http.post(url, params)
}
const delResultAction = (id) => {
  const url = `/config/apiConfigInfo/delete/${id}`
  return http.post(url, {})
}
const getDetailAction = (id) => {
  const url = `/config/apiConfigInfo/get/${id}`
  return http.post(url, {})
}
const searchScheduleAction = (id) => {
  const url = `/config/apiConfigInfo/getScheduled/${id}`
  return http.post(url, {})
}
const scheduleAction = (id, params) => {
  params.id = id
  const url = `/config/apiConfigInfo/saveScheduled`
  return http.post(url, params)
}
const statusAction = (apiID, param) => {
  // const url = `/open/api/v1/outbound-topic/${apiID}/active?active=${param}`
  // return http.post(url, {})
  const url = `/config/apiConfigInfo/changeStatus`
  return http.post(url, {
    id: apiID,
    status: param
  })
}
const searchApiNames = (apiID, param) => {
  const url = '/open/api/v1/outbound-topic/list/api-name'
  return http.post(url, {})
}
const searchInboundAction = (params, current, size) => {
  const url = `/open/api/v1/inbound-topic/list?page=${current}&size=${size}`
  return http.post(url, params)
}
const getInboundActiveAction = (id) => {
  const url = `/open/api/v1/inbound-topic/${id}/get`
  return http.post(url, {})
}
const inboundStatusAction = (apiID, param) => {
  // const url = `/open/api/v1/inbound-topic/${apiID}/active?active=${param}`
  // return http.post(url, {})
  const url = `/config/apiConfigInfo/changeStatus`
  return http.post(url, {
    id: apiID,
    status: param
  })
}
const pingAction = (id) => {
  const url = `/open/api/v1/inbound-topic/${id}/ping`
  return http.post(url, {})
}

const addBoundAction = (params) => {
  const url = `/config/apiConfigInfo/save`
  return http.post(url, params)
}

const getCustAction = () => {
  const url = `/config/customer/list`
  return http.post(url, {})
}
const getBusinessTypeAction = () => {
  const url = `/config/businessTypeInfo/list`
  return http.post(url, {})
}
const getGroovyAction = (client) => {
  const url = `/config/groovyScript/clientList/${client}`
  return http.post(url)
}
const getIngestionAction = (params) => {
  const url = `/config/apiConfigInfo/ingestion/list`
  return http.post(url, params)
}
const getOperationAction = (params) => {
  const url = `/config/apiConfigInfo/ingestion/operationPojo/list`
  return http.post(url, params)
}
const getGroovyDetailAction = (id) => {
  const url = `/config/groovyScript/get/${id}`
  return http.post(url, {})
}

const getViewList = (params) => {
  const url = `/config/apiConfigInfo/getView`
  return http.post(url, params)
}

const getSFTPChooseList = (params) => {
  const url = `/api/v1/file/sftp/fileList`
  return http.post(url, params)
}

const getBlobChooseList = (params) => {
  const url = `/api/v1/file/blob/fileList`
  return http.post(url, params)
}

const runTask = (params) => {
  const url = `/task/apiJob/runJob`
  return http.post(url, params)
}

const generateSql = params => {
  const url = `/config/apiConfigInfo/generateSql`
  return http.post(url, params)
}

export default {
  searchAction,
  searchScheduleAction,
  scheduleAction,
  statusAction,
  searchApiNames,
  searchInboundAction,
  getInboundActiveAction,
  inboundStatusAction,
  pingAction,
  addBoundAction,
  delResultAction,
  getDetailAction,
  getCustAction,
  getBusinessTypeAction,
  getGroovyAction,
  getIngestionAction,
  getOperationAction,
  getGroovyDetailAction,
  getViewList,
  getSFTPChooseList,
  getBlobChooseList,
  runTask,
  generateSql
}
